import React from "react";
import { DailyleafCollectionRouteWiseTableContent } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const headerNames = this.props.headerNames;
        const fullTotalRow = this.props.fullTotalRow;

        return (
            <div>
                <h3><center><u>Daily Leaf Collection Route Wise Summary Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Current Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>
                <div>
                    <table id="example" className="display dataTable no-footer">
                        <thead>
                            <tr>
                                {headerNames.map((x, index) => {
                                    var align = (x === "Name" || x === "Registration Number") ? "left" : "right";
                                    return (
                                        <th style={{ textAlign: align }} key={index}>{x}</th>
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            <DailyleafCollectionRouteWiseTableContent
                                data={reportData}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan="2">Total</th>
                                {
                                    contentRowNames.map((x, i) => {
                                        var res = fullTotalRow.find(y => y.name.toString() === x.toString());
                                        if (res) {
                                            return (
                                                <th key={i} style={{ textAlign: "right" }}>{res.value.toFixed(2)}</th>
                                            );
                                        }
                                    })
                                }
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }
}